module.exports = __webpack_public_path__ + "static/media/tti_talentx_time_save_rate@3x.d5795f5b.png";